module.exports = __webpack_public_path__ + "media/images/new-story-icon-4a4476f7.png";